import './PetCard.scss';
import { useContext, useEffect, useRef, useState } from 'react';
import { ReactComponent as PetCat } from '@/assets/img/v2/pet-cat-default-icon.svg';
import { ReactComponent as PetDog } from '@/assets/img/v2/pet-dog-default-icon.svg';
import { ReactComponent as DeleteIcon } from '@/assets/img/v2/delete.red-icon.svg';
import { ReactComponent as SelectedIcon } from '@/assets/img/v2/selected-item.svg';
import profilePic from '@/assets/img/profile-pic.svg';
import { Pet } from '../types';
type PetCardProps = {
  onChange: (type: Pet) => void;
  data?: Pet;
  isSelected?: boolean;
  showDeleteOption?: boolean;
  onDelete?: (pet: Pet) => void;
};
export const PetCard = ({
  onChange,
  data,
  isSelected,
  showDeleteOption,
  onDelete,
}: PetCardProps) => {
  useEffect(() => {}, [isSelected]);
  const onDeleteClick = (e: any) => {
    e?.stopPropagation();
    onDelete && data && onDelete(data);
  };
  return (
    <div
      className={`pet-list-details ${data?.id ? '' : 'new-pet'} ${
        isSelected ? 'selected-pet' : ''
      }`}
      onClick={() => {
        data && onChange(data);
      }}
    >
      <div className="pet-profile-image">
        {data?.petsImageUrl ? (
          <img src={data?.petsImageUrl} />
        ) : data?.petType?.toLowerCase() === 'cat' ? (
          <PetCat />
        ) : (
          <PetDog />
        )}
      </div>
      <div className="pet-details">
        <div className="name" title={data?.name}>
          {data?.name}
        </div>
        <div className="breed" title={data?.breed}>
          {data?.breed}
        </div>
      </div>
      {showDeleteOption ? (
        <DeleteIcon className="delete-icon" onClick={onDeleteClick} />
      ) : (
        isSelected && <SelectedIcon className="delete-icon" />
      )}
    </div>
  );
};
